import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { constant } from "common/constant";
import { postApiMultipart } from "common/services/api";
import { API_PATHS } from "common/services/apiPaths";

export const uploadAttachment = createAsyncThunk(
  "attachments/uploadAttachment",
  async ({ file, setFieldValue, fieldName }, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("file", file);

      const response = await postApiMultipart(API_PATHS.RECRUITMENT_ATTACHMENTS_UPLOAD, formData);

      if (response.status === 201) {
        const attachmentId = response.data._id;

        if (setFieldValue) setFieldValue(fieldName, attachmentId);

        toast.success(constant.fileUploadSuccessfully);
        return attachmentId;
      } else {
        return rejectWithValue(constant.fileUploadFailed);
      }
    } catch (error) {
      toast.error(constant.somethingWentWrong);
      return rejectWithValue(error.message || constant.uploadFailed);
    }
  }
);

const attachmentsSlice = createSlice({
  name: "attachments",
  initialState: {
    attachmentId: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(uploadAttachment.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(uploadAttachment.fulfilled, (state, action) => {
        state.loading = false;
        state.attachmentId = action.payload;
      })
      .addCase(uploadAttachment.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default attachmentsSlice.reducer;
